import LargePlayer from '../../components/largePlayer.js';

document.querySelectorAll('[data-large-player]').forEach(
  video => new LargePlayer(video));
